import Vue from 'vue'
import Router from 'vue-router'
import paths from './paths'

function route (path, view, name, meta) {
  return {
    name: name || view,
    path,
    meta : meta,
    component: (resolve) => import(
      `@/screens/${view}.vue`
    ).then(resolve),
    beforeEnter : async (to, from, next) => {
      if (to.matched.some(record => record.meta.requiresAuth)) {
        try {
          await Vue.prototype.$Amplify.Auth.currentAuthenticatedUser();
          next();
        } catch (e) {
          next({
            path: "/",
            query: {
              redirect: to.fullPath
            }
          });
        }
      } else if (to.matched.some(record => record.meta.requiresPower)) {
        if( Vue.prototype.$store.state.isCurrentUserPowerUser == false ) {
          next({
            path: "/",
            query: {
              redirect: to.fullPath
            }
          });
        } else {
          next();
        }
      } else {
        next();
      }
    }
  }
}

export default new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: paths.map(path => route(path.path, path.view, path.name, path.meta)).concat([
    { path: '*', redirect: '/' }
  ])
})

Vue.use(Router)
